"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const quasar_1 = require("quasar");
/**
 * Handle PWA application update
 *
 * When new update detected show information to user and allow to update (refresh)
 * Optional clear all cached data
 *
*/
exports.default = {
    data: () => ({
        registration: null,
        isRefresh: false,
        refreshing: false
    }),
    created() {
        // Listen for custom event trigged on service worker `updated` callback
        document.addEventListener('serviceWorkerUpdateEvent', this.newVersionNotify, { once: true });
        /*
        // To automatically refresh app when service worker updated
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (this.refreshing) return
          this.refreshing = true
          // Here the actual reload of the page occurs
          window.location.reload()
        })
        */
    },
    methods: {
        newVersionNotify: function (e) {
            this.registration = e.detail;
            this.isRefresh = true;
            this.$q.notify({
                message: 'New version available',
                position: 'bottom-right',
                type: 'info',
                timeout: 0,
                badgeStyle: 'display:none;',
                actions: [
                    {
                        label: 'UPDATE NOW',
                        color: 'white',
                        handler: () => {
                            this.update();
                        }
                    }
                    // , { icon: 'close', color: 'white', handler: () => { /* ... */ } }
                ]
            });
        },
        /**
         * Update / install new app version (refresh page)
         *
         * @param {Boolean} clearAllCache   if true clear all cache/storage
         * @return {void}
         */
        update(clearAllCache = false) {
            this.isRefresh = false;
            if (clearAllCache) {
                this.clearAllStorages();
            }
            if (this.registration && this.registration.waiting) {
                this.registration.waiting.postMessage('skipWaiting');
                // this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
            }
            // re-load to install new version
            setTimeout(() => {
                // prevent multiple refreshes
                if (!this.refreshing) {
                    this.refreshing = true;
                    window.location.reload();
                }
            }, 300);
        },
        /**
         * Clear application all storage
         */
        clearAllStorages() {
            // clear all cookies
            try {
                const allCookies = quasar_1.Cookies.getAll();
                for (let cookie of Object.keys(allCookies)) {
                    quasar_1.Cookies.remove(cookie);
                }
            }
            catch (error) { }
            // clear service worker (pre)cached resources
            try {
                caches.keys().then(function (names) {
                    for (let name of names) {
                        caches.delete(name);
                    }
                });
            }
            catch (error) { }
            // clear apollo store
            try {
                this.$apollo.getClient().resetStore();
            }
            catch (error) { }
            // clear local storage
            try {
                localStorage.clear();
            }
            catch (error) { }
        }
    }
};
